import { createAction } from '@reduxjs/toolkit';
export const forgeLogout = createAction('provider/forge/logout');
export const forgeLogoutRejected = createAction('provider/forge/logout/rejected');
export const forgeLogoutWithEmulation = createAction('provider/forge/logoutWithEmulation');
export const forgeLogoutWithEmulationRejected = createAction('provider/forge/logoutWithEmulation/rejected');
